import { base64ToBlob, removeAccentsAndSpecialChars, shortenName } from "../../app/utils/helpers";
import http from "../../config/http";
import { DROP_DOCUMENTO_TIPO_CERTIFICACION, DROP_TIPOS_CERTIFICACIONES, FEATURE_FLAGS, GET_ALL_BITACORA, GET_ESTADOS_SOLICITUDES,GET_TIPO_SOLICITUDES, GET_TIPOS_AUTORIZACIONES, GUARDAR_INFORMACION_BANCARIA, OBTENER_INFORMACION_BANCARIA } from "../endpoints";

const getAllBitacoraByCode = (codigoAfiliado, token = null) => {
  let configuration;

  if(token)
  {
     configuration = {
        headers: {"Authorization": "Bearer " + token}
      }
      return http.get(`utility/${GET_ALL_BITACORA}?CodigoAfiliado=${codigoAfiliado}`,configuration);
  }

   configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }
  
  return http.get(`utility/${GET_ALL_BITACORA}?CodigoAfiliado=${codigoAfiliado}`,configuration);

};

const getEstadoSolicitudes = () => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${GET_ESTADOS_SOLICITUDES}`,configuration);

}

const getTipoSolicitudes = () => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${GET_TIPO_SOLICITUDES}`,configuration);

}

const getTipoAutorizaciones = () => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${GET_TIPOS_AUTORIZACIONES}`,configuration);

}

const getFeatureFlags = () => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${FEATURE_FLAGS}`,configuration);

}

const getTiposCertificaciones = () => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${DROP_TIPOS_CERTIFICACIONES}`,configuration);

}

const getDocumentosTipoCertificacion = (tipo) => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${DROP_DOCUMENTO_TIPO_CERTIFICACION}?tipoCertificacion=${tipo}`,configuration);

}

const getObtenerInformacionBancariaPorAfiliado = (contrato) => {
  let configuration;

  configuration = {
    headers: {"Authorization": "Bearer " + localStorage.getItem("token")}
  }

  return http.get(`utility/${OBTENER_INFORMACION_BANCARIA}?IdAfiliado=${contrato}`,configuration);

}

const postSolicitudInformacionBancariaAfiliado = (_id, _idAfiliado, _idBanco, _nombre, _numeroCuenta, _numeroDocumento, _tipoCuenta, _tipoDocumento, image) => {

  const outputArray = [];
  const nameCount = {};
  
  image.forEach((item, index) => {
    let baseName = removeAccentsAndSpecialChars(item.type);
    baseName = shortenName(baseName, 20);

    if (nameCount[baseName]) {
        nameCount[baseName] += 1;
    } else {
        nameCount[baseName] = 1;
    }

    const count = nameCount[baseName];
    const newName = count > 1 ? `${baseName}_${count}` : baseName;
    const fileExtension = item.name.split('.').pop();
    const formattedName = `${newName}.${fileExtension}`;

    const blob = base64ToBlob(item.content, item.fileType);
    const newFile = new File([blob], formattedName, { type: item.fileType });
    outputArray.push(newFile);
});

const bodyFormData = new FormData();
outputArray.forEach(item => {
    bodyFormData.append('images', item);
});

    bodyFormData.append("Id",_id)
    bodyFormData.append("IdAfiliado",_idAfiliado)
    bodyFormData.append("IdBanco",_idBanco)
    bodyFormData.append("NombreApellido",_nombre)
    bodyFormData.append("NumeroCuenta",_numeroCuenta)
    bodyFormData.append("NumeroDocumento",_numeroDocumento)
    bodyFormData.append("TipoCuenta",_tipoCuenta)
    bodyFormData.append("TipoDocumento",_tipoDocumento)
    
    return http.post(`utility/${GUARDAR_INFORMACION_BANCARIA}`,bodyFormData,{
        headers: { "Content-Type": "multipart/form-data",  Authorization: 'Bearer ' + localStorage.getItem('token'), Procedencia: 16  }
    })
}


export { 
  getAllBitacoraByCode, 
  getEstadoSolicitudes, 
  getTipoSolicitudes,
  getTipoAutorizaciones,
  getFeatureFlags,
  getTiposCertificaciones,
  getDocumentosTipoCertificacion,
  getObtenerInformacionBancariaPorAfiliado,
  postSolicitudInformacionBancariaAfiliado 
};